<template>
  <div>
    <div class="home">
      <div class="top_nav">
        <span v-if="topic_id" :class="{ active: Boolean(topic_id) }">圈子</span>
        <span style="color:#000" v-else :class="{ active: !topic_id }"
          >发现</span
        >
      </div>

      <div
        v-for="(item, index) in topic_data"
        :key="index"
        class="top_banner_box"
        :style="{
          background: 'url(' + item.background + ') no-repeat',
          backgroundSize: '100% 100%'
        }"
      >
        <div v-if="topic_id">
          <div class="game_box">
            <div
              class="game_icon"
              :style="{
                background: 'url(' + item.logo + ') no-repeat',
                backgroundSize: '100% 100%'
              }"
            ></div>
            <div class="game_info">
              <p class="game_name">{{ item.name }}</p>
              <p>{{ item.slogan }}</p>
            </div>
          </div>
          <div class="bottom_nav">
            <ul>
              <li
                v-for="(item1, index1) in item.menus[0].contents"
                :key="index1"
                @click="showDownloadBox"
              >
                <div class="nav_icon">
                  <img :src="item1.icon" alt="" />
                </div>
                <div class="nav_name">{{ item1.title }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="!topic_id" class="find_top"></div>
    </div>
    <!-- 帖子列表 -->
    <topic-item :type="false" />

    <!-- 下载盒子 -->
    <download
      v-model="download_show"
      v-if="download_show"
      @closepop="closepop"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import { Tab, Tabs, Button } from "vant";
import { getTopicsDataApi } from "@/api/home";

export default {
  name: "home",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    download: () => import("../components/download"),
    topicItem: () => import("../components/table-list")
  },
  data() {
    return {
      tab_active: 0,
      topic_id: this.$store.state.topic_id,
      topic_data: {},
      download_show: false
    };
  },

  created() {
    // 判断是否有圈子id
    if (this.topic_id) {
      this.getTopicsData(this.topic_id).then(res => {
        this.topic_data = [res];
      });
    } else {
      this.tabs = "发现";
    }
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
    },

    // 获取圈子详情信息
    getTopicsData(topic_id) {
      return new Promise((resolve, reject) => {
        getTopicsDataApi(topic_id)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 出现下载盒子
    showDownloadBox() {
      this.download_show = true;
    },

    closepop() {
      this.download_show = false;
    }
  }
};
</script>

<style scoped>
@import "../assets/index.css";
@import "../assets/common.css";
</style>
